import { useSetRecoilState } from 'recoil';

import { notificationState } from 'state/atoms';

const useNotifyError = ({ fallbackMessage = '', ...notificationProps } = {}) => {
  const setNotification = useSetRecoilState(notificationState);

  return (error = {}) => {
    const errorMessage = error.message || '';
    const messageIsValid = /^Error:/g.test(errorMessage);

    setNotification({
      type: 'error',
      show: true,
      text: messageIsValid ? error.message : fallbackMessage,
      ...notificationProps,
    });
  };
};

export { useNotifyError };
